import type { Random } from "../types";

/**
 * Deterministic PRNG (Mulberry32) that satisfies the core `Random` contract.
 * Inject this (not `Math.random`) into any system that needs randomness so
 * that identical seeds produce identical simulations.
 */
export class SeededRandom implements Random {
  private state: number;

  constructor(seed: number) {
    // Non-zero, integerized initial state for Mulberry32.
    this.state = seed >>> 0 || 0x9e3779b9;
  }

  next(): number {
    let t = (this.state += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  /** 导出确定性 RNG 当前状态，供运行态快照使用。 */
  snapshot(): number {
    return this.state >>> 0;
  }

  /** 恢复确定性 RNG 当前状态。 */
  restore(state: number): void {
    if (!Number.isInteger(state) || state < 0 || state > 0xffffffff) {
      throw new Error(`SeededRandom.restore: invalid state ${state}`);
    }
    this.state = state >>> 0;
  }
}
